import { render, staticRenderFns } from "./message-content-bulk-message-opt-event.vue?vue&type=template&id=5f57c8a8&scoped=true&"
import script from "./message-content-bulk-message-opt-event.vue?vue&type=script&lang=js&"
export * from "./message-content-bulk-message-opt-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57c8a8",
  null
  
)

export default component.exports